import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Rodal from "rodal";
import {
  main_url,
  startSaving,
  getUserId,
  remote_url,
  getUserInfoLogin,
  handleLoginCall,
  setLoginUserInfo,
} from "../../utils/CommonFunction";
import { Redirect } from "react-router-dom";
import Navigation from "../Navigation";
import { getHeaders } from "../../utils/apiHelper";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login_password: "",
      isShowGoBackConfirm: false,
      isLoginSuccessful: false,
    };
  }

  async componentDidMount() {
    // let user = getUserInfoLogin(this.props.user_id);
    // console.log(user);
  }

  goBackSSO() {
    window.location = remote_url;
  }

  showGoBackConfirm() {
    this.setState({ isShowGoBackConfirm: true });
  }
  hideGoBackConfirm() {
    this.setState({ isShowGoBackConfirm: false });
  }

  handleLoginPassword = (event) => {
    this.setState({
      login_password: event.target.value,
    });
  };

  clickLoginHandle() {
    let alertText = "";
    if (this.state.login_password === "") {
      alertText = "Please enter password!";
      toast.error(alertText);
      return;
    }
    // hrmLogin;

    let loginData = {
      user_id: this.props.user_id,
      password: this.state.login_password,
    };

    const formdata = new FormData();

    formdata.append("loginData", JSON.stringify(loginData));

    // let user = handleLoginCall(formdata);
    // console.log(user);

    let status = 0;

    fetch(main_url + "main/hrmLogin", {
      method: "POST",
      headers: getHeaders(true),
      body: `loginData=${JSON.stringify(loginData)}`,
    })
      .then((res) => {
        status = res.status;
        if (status === 200) return res.json();
        else return res.text();
      })
      .then((data) => {
        if (status === 200) {
          console.log("HEre is data", data[0]);
          setLoginUserInfo(data[0]);
          this.setState({
            isLoginSuccessful: true,
          });
          window.location.pathname = "dashboard";
        } else {
          toast.error(data);
        }
      })
      .catch((err) => {
        console.log("Here is error >>>>>>>>>>>>>>>>>>>>>>>", err);
        toast.error(err);
      });
  }

  render() {
    if (this.state.isLoginSuccessful) {
      return <Navigation />;
    }
    return (
      <>
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />

        <div
          className=""
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="row col-md-4"
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "10px",
            }}
          >
            <form id="check_form">
              <div className="row">
                <div className="form-group col-md-12">
                  <div className="col-md-12">
                    <label style={{ color: "" }}>
                      Please Enter Password To Use HRM Software
                    </label>
                  </div>
                  <div className="col-md-12">
                    <input
                      style={{ zIndex: "1000" }}
                      type="text"
                      className="form-control input-md"
                      value={this.state.login_password}
                      onChange={this.handleLoginPassword.bind(this)}
                      placeholder="Please Enter Login Password"
                    />
                  </div>
                </div>
                <div
                  className="form-group col-md-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-primary"
                    id="saving_button"
                    type="button"
                    onClick={this.clickLoginHandle.bind(this)}
                  >
                    Login
                  </button>
                </div>

                <div
                  className="form-group col-md-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <p
                    className="go-back-sso"
                    onClick={this.showGoBackConfirm.bind(this)}
                  >
                    Go back to SSO Login
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>

        <Rodal
          style={{ zIndex: "100000" }}
          width={500}
          height={120}
          visible={this.state.isShowGoBackConfirm}
          onClose={this.hideGoBackConfirm.bind(this)}
        >
          <div className="col-md-12 ">
            <h4> Are you sure you want to go back to SSO Login? </h4>
          </div>

          <div
            className="col-md-12"
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              className="btn btn-primary"
              id="saving_button"
              type="button"
              onClick={this.goBackSSO.bind(this)}
            >
              Confirm
            </button>
            &nbsp; &nbsp; &nbsp;
            <button
              className="btn btn-secondary"
              id="saving_button"
              type="button"
              onClick={this.hideGoBackConfirm.bind(this)}
            >
              Cancel
            </button>
          </div>
        </Rodal>
      </>
    );
  }
}
